import { Accordion } from '@scripts/accordion/classes/Accordion.js';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.accordion').forEach(accordion => {
        new Accordion(accordion);
    });
});
